import React from "react";
import ShopDetails from "../Components/Shop/ShopDetails/ShopDetails";
import MarqueeText from "../Components/Shop/MarqueeText/MarqueeText";

const Shop = () => {
  return (
    <>
      <ShopDetails />
    </>
  );
};

export default Shop;
